import React, { useEffect } from 'react';

import { jwtDecode } from 'jwt-decode';
import { useHistory, useLocation } from 'react-router-dom';
import UserActions from '~/stormpath/actions/UserActions';

interface GoogleTokenData {
  sub: string;
  email: string;
  given_name: string;
  family_name: string;
}

function SocialGoogleButton() {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    /* global google */
    (google as any).accounts.id.initialize({
      client_id: window.configs.GOOGLE_APP_ID,
      callback: onSuccess,
    });

    (google as any).accounts.id.renderButton(document.getElementById('my-signin2'), {
      theme: 'filled_blue',
      text: 'continue_with',
      locale: 'en_AU',
      size: 'large',
    });
  }, []);

  function onSuccess(data) {
    const tokenData = jwtDecode<GoogleTokenData>(data.credential);
    const loginWithGoogleData = {
      id_google: tokenData.sub,
      email: tokenData.email,
      token_id: data.credential,
      givenName: tokenData.given_name,
      surname: tokenData.family_name,
    };
    UserActions.loginWithGoogle(loginWithGoogleData, (err, result) => {
      let redirectUrl = '/';
      if (location) {
        redirectUrl = location.pathname + location.search;
      }
      history.push(redirectUrl);
    });
  }

  return <div id="my-signin2">Continue with google</div>;
}

export default SocialGoogleButton;
